const store = {};
function modules2Obj(mds) {
    for (const PATH of mds.keys()) {
        if (PATH === './index.js') continue;
        store[PATH.replace(/^\.\/(.*)\.\w+$/, '$1')] = mds(PATH).default;
    }
}
modules2Obj(require.context('&/store', false, /\.js$/));
modules2Obj(require.context('@/store', false, /\.js$/));
export default store;
